<div id="mainFreightItinerary" class="col-md-12 mb-md-0 mb-12">
  <div class="row h-100">

    <mat-tab-group class="tab-group" permission-tab (selectedIndexChange)="onSelectTab($event)"
      [permissionModule]="permission.cargo.module" [permissionListName]="permissions"
      [(selectedIndex)]="selectedTabIndex">
      <mat-tab *ngFor="let tab of tabs; let i = index" [label]="tab.alias">
        <ng-container [ngSwitch]="tab.component" *ngIf="selectedTabIndex === i">
          <app-create-cargo *ngSwitchCase="'app-create-cargo'">
          </app-create-cargo>
          <app-mass-creation-cargo *ngSwitchCase="'app-mass-creation-cargo'">
          </app-mass-creation-cargo>
          <app-upload-route *ngSwitchCase="'app-upload-route'">
          </app-upload-route>
          <app-upload-download-map-freight *ngSwitchCase="'app-upload-download-map-freight'">
          </app-upload-download-map-freight>
          <app-create-escort-service *ngSwitchCase="'app-create-escort-service'">
          </app-create-escort-service>
          <app-create-satellite-lock-service *ngSwitchCase="'app-create-satellite-lock-service'">
          </app-create-satellite-lock-service>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

  </div>
</div>